import FadeUp from "./FadeUp";
import { CONTACT } from "../data/content";

const PERKS = [
  "Instant fare quotes, no hidden charges",
  "Confirm your booking on call or WhatsApp",
  "24×7 support before and during your trip",
];

export default function OfferBanner() {
  const waHref = `https://wa.me/${CONTACT.wa}?text=Hi%20JSR%20Travels%2C%20I%20want%20to%20claim%20the%2030%25%20off%20first%20booking%20offer`;

  return (
    <section className="bg-white py-16">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <FadeUp>
          <div className="relative overflow-hidden rounded-card bg-gradient-to-br from-brand to-brand-dark px-8 py-12 text-white sm:px-12">
            {/* Decorative blobs */}
            <div className="pointer-events-none absolute -right-10 -top-10 h-48 w-48 rounded-full bg-white/10" />
            <div className="pointer-events-none absolute -bottom-16 left-1/3 h-48 w-48 rounded-full bg-accent/20" />

            <div className="relative grid items-center gap-10 lg:grid-cols-2">
              <div>
                <p className="mb-3 inline-flex rounded-full bg-accent px-4 py-1 text-sm font-semibold">
                  Limited Offer
                </p>
                <h2 className="font-heading text-3xl font-extrabold leading-tight sm:text-4xl">
                  30% Off On Your <br /> First Booking
                </h2>
                <p className="mt-3 max-w-md text-white/85">
                  Book your cab, traveller or bus directly with us and
                  save on your first ride. Call or message our team and we&apos;ll
                  confirm your trip in minutes.
                </p>

                <ul className="mt-6 space-y-2.5">
                  {PERKS.map((perk) => (
                    <li
                      key={perk}
                      className="flex items-start gap-2.5 text-sm text-white/90"
                    >
                      <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-white/20">
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          className="h-3 w-3"
                          aria-hidden="true"
                        >
                          <path
                            d="m5 13 4 4L19 7"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      {perk}
                    </li>
                  ))}
                </ul>

                <div className="mt-7 flex flex-wrap gap-4">
                  <a
                    href={waHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 rounded-full bg-white px-6 py-3 font-heading font-semibold text-brand transition-transform hover:-translate-y-0.5"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="h-5 w-5"
                      aria-hidden="true"
                    >
                      <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15s-.77.96-.94 1.16c-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.48-1.75-1.65-2.05-.17-.3-.02-.46.13-.61.14-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.06 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.28.17-1.41-.07-.13-.27-.2-.57-.35Z" />
                      <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.86 9.86 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2Zm0 18.13h-.01a8.2 8.2 0 0 1-4.18-1.15l-.3-.18-3.11.82.83-3.04-.2-.31a8.19 8.19 0 0 1-1.26-4.36c0-4.54 3.7-8.24 8.24-8.24a8.19 8.19 0 0 1 8.23 8.25c0 4.54-3.7 8.21-8.24 8.21Z" />
                    </svg>
                    Book on WhatsApp
                  </a>
                  <a
                    href={`tel:${CONTACT.persons[0].tel}`}
                    className="inline-flex items-center gap-2 rounded-full border-2 border-white/60 px-6 py-3 font-heading font-semibold text-white transition-all duration-300 hover:bg-white hover:text-brand"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="h-5 w-5"
                      aria-hidden="true"
                    >
                      <path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.03-.24 11.4 11.4 0 0 0 3.56.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.56a1 1 0 0 1-.25 1.03l-2.2 2.2Z" />
                    </svg>
                    {CONTACT.persons[0].phone}
                  </a>
                </div>
              </div>

              {/* Offer card */}
              <div className="relative mx-auto w-full max-w-sm">
                <div className="rounded-card bg-white/10 p-8 text-center backdrop-blur-sm ring-1 ring-white/20">
                  <p className="font-heading text-sm uppercase tracking-widest text-white/70">
                    Save up to
                  </p>
                  <p className="mt-2 font-heading text-7xl font-extrabold leading-none">
                    30<span className="text-accent">%</span>
                  </p>
                  <p className="mt-3 font-heading text-lg font-semibold">
                    On your first trip
                  </p>
                  <p className="mt-4 border-t border-white/20 pt-4 text-sm text-white/75">
                    Valid on airport transfers, outstation trips and tour
                    packages.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
